import * as F from 'reduker/fp-utils'
// import entities from 'reduker/entities'
import request from 'reduker/request'

export const getVendorInfo = state => state.vendorDetails.vendorInfo
export const getCountriesInfo = state => state.config.countries
export const getCPVInfo = state => state.config.CPV

export const getPruebaRequest = state => state.vendorDetails.request

export const getIsPruebaFetching = F.pipe(
  getPruebaRequest,
  request.getIsRequesting,
)
